<template>
  <div>
    <span class="sr-only">{{ getAriaText(params) }}</span>
    <c-action-buttons-bar
      :wid="parent.wid"
      class="trading-button"
      :symbol="symbol"
      :disableButtons="['alert', 'buyCover', 'sellShort']"
      :disableBtnClick="disableBtnArr"
      :buy="() => openOrderEntry('BUY')"
      :sell="() => openOrderEntry('SELL')"
      :cover="() => openOrderEntry('COVER')"
      :short="() => openOrderEntry('SHORT')"
      :params="this.params"
      :accountId="accountId"
      :isTypeOption="isTypeOption()"
      v-if="isSymbolValid"
      ref="dropdown"
    ></c-action-buttons-bar>
  </div>
</template>

<script>
import CActionButtonsBar from '@custom/CActionButtonsBar';
import { getAriaText } from '@utils/helpers';

export default {
  name: 'td-trade-button-renderer',
  components: {
    CActionButtonsBar
  },
  data() {
    return {
      symbol: null,
      underlyingSymbol: null,
      isOption: false,
      isFractional: false,
      quantity: null,
      accountId: null
    };
  },
  computed: {
    isSymbolValid() {
      return !this._.isEmpty(this.symbol) && (this.isOption ? !this._.isEmpty(this.underlyingSymbol) : true);
    },
    accounts() {
      return this.$store.getters['accounts/getAccountData'];
    },
    orderEntryAccounts() {
      return this.$store.getters['accounts/getOrderEntryAccountData'];
    },
    disableBtnArr() {
      if (!this.params['isOrderEntryAccount']) {
        return ['buy', 'sell'];
      } else return [];
    },
    isShortPosition() {
      return Number.parseInt(this.quantity) < 0;
    },
    parent() {
      return this.params.context;
    },
    defaultQuantity() {
      if (this.isOption) {
        return this.$store.state.applicationSettings.orders.settings.options.defaultOrderQuantity;
      } else {
        return this.$store.state.applicationSettings.orders.settings.stocks.defaultOrderQuantity;
      }
    },
    defaultFractionalType() {
      return this.$store.state.applicationSettings.orders.settings.stocks.defaultFractionalType;
    },
    isFractionalTradingAllowed() {
      return this.$store.getters['accounts/isFractionalTradingAllowed'];
    }
  },
  mounted() {
    this.setParams(this.params);
  },
  methods: {
    getAriaText,
    isClose(action) {
      return (
        this.accountId &&
        (((action === 'SELL' || action === 'SHORT') && !this.isShortPosition) ||
          ((action === 'BUY' || action === 'COVER') && this.isShortPosition))
      );
    },
    setParams(params) {
      Object.entries(params).forEach(([k, v]) => {
        if (this[k] !== undefined) {
          this[k] = v;
        }
      });
    },
    openOrderEntry(action) {
      let isFractional = this.params['isFractional'] && action !== 'BUY';
      if (!this.isFractionalTradingAllowed) {
        this.quantity = Number.parseInt(this.quantity);
      }
      this.$widget.openOrderEntry({
        orderMode: { action: action, modifier: '', close: this.isClose(action) },
        legs: {
          firstOrder: {
            symbol: { ric: this.symbol },
            underlying: { ric: this.underlyingSymbol || this.symbol },
            ticketType: isFractional ? 'fractional' : this.isOption ? 'option' : 'stock',
            quantity:
              (action === 'BUY' && !this.isShortPosition) || (action === 'SHORT' && this.isShortPosition)
                ? this.defaultQuantity
                : this.quantity,
            // sell Nontional orders are not allowed
            fractionalQuantityType: isFractional ? '#' : '',
            isFractional: isFractional
          }
        },
        accountId: this.accountId
      });
    },
    refresh(params) {
      this.setParams(params);
      return true;
    },
    invokeFirstButtonPress(value) {
      let isShiftTab = value.shiftKey && value.key === 'Tab';
      if (isShiftTab) {
        value.preventDefault();
        this.params.context.invokeTabPreviousCell();
      }
    },
    invokeSecondButtonPress(value) {
      let isTab = !value.shiftKey && value.key === 'Tab';
      if (isTab) {
        value.preventDefault();
        this.params.context.invokeTabNextCell();
      }
    },
    isTypeOption() {
      return this.params.data.symbol && this.params.data.symbol.type === 'OPTION';
    }
  }
};
</script>
<style lang="scss">
.c-action-buttons-bar.trading-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  margin: 0;

  // do not style first element
  .btn + .btn {
    margin-left: calc-em(2px) !important;
  }

  > .btn {
    flex: 1;
    margin: 0 !important;
    text-transform: capitalize;
    outline: none;

    &.focus,
    &:focus {
      box-shadow: none;
      outline: 1px auto;
    }
  }
  button:disabled {
    opacity: 0.4;
  }
  button:not(:hover),
  button:disabled {
    color: get-theme-color('secondary', 'lighten-2');
    border-color: $gray-400;
  }
}
</style>
